/**
 * this module is used to overwrite all project dependent client config options handled by frontend-controller/lib/appConfig.js
 */
module.exports = {
	useFecClient: true,
	heartbeatConfig: {
		turnedOn: true, // heartbeat server-side-events may be used if granted.
	},
	store: {
		name: 'BackOfficeStore'
	},
	environment: { // environment configs children will not be merged.
		// minDeltaUpdate: 500, // do not update a clients environment more often than this number of milliseconds.
		// minDeltaServerUpdate: 5000, // do not send a clients environment update more often than this number of milliseconds to the server.
		styles: [ // which styles are available
			'mobile',
			'desktop',
		],
		style: { // list of styles associated with a device and optional a breakpoint.
			phone: 'mobile',
			tablet: {
				xs: 	'mobile',
				s: 		'mobile',
				m: 		'mobile',
				l: 		'desktop',
				xl: 	'desktop',
				xxl: 	'desktop',
			},
			desktop: {
				xs: 'mobile',
				s: 'mobile',
				m: 'mobile',
				l: 'desktop',
				xl: 'desktop',
				xxl: 'desktop',
			}
		},
		// list of devices and their breakpoints (or just plain breakpoints) and their max window.width in pixel.
		// layouts.desktop.xs = 400 means if a desktop device with a window.width smaller than 400 the breakpoint xs is active.
		// NOTE: if the string.length of a key is greater than 3 it is considered a device and a breakpoint otherwise.
		layouts: {
			// device independent breakpoint variant.
			xs: 400,
			s: 600,
			m: 1024,
			l: 1600,
			xl: 1920,
			xxl: 3840,
		},
	},
	// @see MARK: MARK: FEC_LANGUAGE_CONFIG
	language: {
		default: 'de-at',
		available: {
			'de-at': {
				icon: 'flag-icon flag-icon-at',
				title: 'DE',
			},
		},
		// @see MARK: FEC_TRANSLATION_MANAGER
		i18next: {
			ns: ['common', 'error', 'button', 'statusFlags'], // list of namespaces to support.
			// defaultNS: 'common', // default namespace
			// debug: true, // should i18next be chatty on the console for debugging purposes?
		},
	},
	cache: {
		reuseCachedHtml: false,
		grantCacheByETag: true,		// should the fec client be allowed to cache requests based on etag?
	},
	render: {
		suppressEmptyTemplates: (process.env.NODE_ENV || 'production') === 'production'		// should the empty default template and the corresponding warnings be suppressed?
	},
	debug: {
		componentListDebugging: false,
	},
	timeMeasurement: false,
	statusControllerActionHandling: true,
	validator: {
		defaultLocale: 'de-DE'
	},
	useIDSelector: true,
	docs: {
		authenticatedOnly: true,
		scopeRole: {
			scope: 'office',
			option: 'showDocs',
		},
	},

	envOverride: { // overrides original config based on NODE_ENV variable
		// development: {
		// 	timeMeasurement: true,
		// },
	},
};
